<template>
  <div>
    <el-form ref="formRef" :model="blackForm" label-width="88px">
      <el-form-item label="内容：">
        <el-input v-if="idx == -1" :rows="8" type="textarea" v-model="blackForm.content" placeholder="输入关键词（每行一个）" style="width:24em;"/>
        <el-input v-else v-model="blackForm.content" placeholder="输入关键词" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="类型：">
        <el-select v-model="type" placeholder="Select" style="width: 24em">
          <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { addOrUpdateBlockRule } from "@/api/url";

export default {
  name: "BlackRuleDialog",
  props: {
    value: Object
  },
  data() {
    return {
      blackForm: this.value.blackForm,
      idx: this.value.ids,
      loading: false,

      typeArray: [
        {label: '星号代替后发送', value: 1},
        {label: '发送默认文案', value: 2},
        {label: '含有即不发送', value: 3},
        {label: '含有即不发送（感叹号）', value: 5},
        {label: '标记发送', value: 4},
        {label: '标记联系方式', value: 6},
      ],
      type: this.value.blackForm.type?this.value.blackForm.type:1,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },


    summit() {
      if(!this.blackForm.content) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '关键词不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = {};
      param['id'] = this.blackForm.id?this.blackForm.id:0;
      param['content'] = this.blackForm.content;
      param['type'] = this.type;
      postFormData(addOrUpdateBlockRule, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
